import {Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormioCustomComponent} from "@formio/angular";
import {combineLatest, Observable, Subscription} from "rxjs";
import {PortalDataService} from "../../../../core/services/portal-data/portal-data.service";
import {CatalogDataService} from "../../../../core/services/catalog-data/catalog-data.service";

@Component({
  selector: 'sb-dynamic-formio',
  templateUrl: './dynamic-formio.component.html',
  styleUrls: ['./dynamic-formio.component.scss']
})
export class DynamicFormioComponent implements FormioCustomComponent<string>, OnInit, OnDestroy {

  id: string;

  @Input()
  disabled: boolean;

  @Input()
  value: string;

  @Output()
  valueChange: EventEmitter<string> = new EventEmitter<string>();

  @Input()
  parameters: any;

  @Input()
  parametersJSON: string;

  @Input()
  preview: boolean;

  @Input()
  formioComponent: any;

  componentsLoaded$: Observable<[boolean,boolean]>;

  constructor(private portalDataService: PortalDataService, private catalogDataService : CatalogDataService, private hostElement: ElementRef) {
    // Most reliable way to get the id
    this.id = this.hostElement.nativeElement.tagName.split('-')[1].toLowerCase();
  }

  ngOnInit() {
    this.componentsLoaded$ = combineLatest([this.portalDataService.portalComponentsLoaded, this.catalogDataService.catalogLoaded]);
  }

  ngOnDestroy() {
  }
}
